import { useFormContext } from "react-hook-form";

import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepFeedback } from "../components/step-feedback";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";
import { useFunnelAnswers } from "../hooks/useFunnelAnswers";

import { ChoiceBoxContent } from "./components/choice-box-content";
import type { StepProps } from "./step.types";

export default function HasMinorChildren({ experiments }: StepProps) {
  const { funnelAnswers } = useFunnelAnswers();
  const { subPractice } = funnelAnswers;
  const { t } = useTranslation();
  const choices = [
    {
      label: t("FUNNEL_HAS_MINOR_CHILDREN_CHOICE_YES"),
      value: "Yes",
      feedback: t("FUNNEL_HAS_MINOR_CHILDREN_CHOICE_YES_FEEDBACK"),
    },
    {
      label: t("FUNNEL_HAS_MINOR_CHILDREN_CHOICE_NO"),
      value: "No",
      feedback: t("FUNNEL_HAS_MINOR_CHILDREN_CHOICE_NO_FEEDBACK"),
    },
  ];

  const { abTestDivorceFlowEnabled } = experiments;

  const isAbTestDivorceFlowEnabled =
    abTestDivorceFlowEnabled && subPractice === "divorce";

  const { watch } = useFormContext();
  const hasMinorChildren = watch(funnelInputsNameMap.hasMinorChildren);
  const feedback = hasMinorChildren
    ? choices.find(({ value }) => value === hasMinorChildren)?.feedback
    : "";

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>
            {isAbTestDivorceFlowEnabled
              ? t("FUNNEL_HAS_MINOR_CHILDREN_TITLE_V1")
              : t("FUNNEL_HAS_MINOR_CHILDREN_TITLE")}
          </StepTitle>
          {isAbTestDivorceFlowEnabled && (
            <StepSubtitle className="text-body1">
              {t("FUNNEL_HAS_MINOR_CHILDREN_SUBTITLE_V1")}
            </StepSubtitle>
          )}
          <ChoiceBoxContent
            name={funnelInputsNameMap.hasMinorChildren}
            choices={choices}
            required
          />
          <StepFeedback>{feedback}</StepFeedback>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
